import NextLink from 'next/link';

import { Callout, PageIntro } from '@frontendmentorio/design-system-v2';

import FAQs from 'features/shared/FAQs';

export default function FAQsPage() {
  return (
    <>
      <PageIntro
        className="text-neutral-500"
        heading="Frequently Asked Questions"
      >
        <p>
          If you’ve got a question, there’s a good chance we’ve answered it
          below. Take a look and if you still need help, get in touch, and we’ll
          happily help you out!
        </p>
      </PageIntro>

      <div className="flex flex-col gap-8 px-5 py-6">
        <div className="container-sm flex flex-col gap-8">
          <FAQs heading="General questions">
            <FAQs.FAQ question="What does this platform do, and how will it help me?" />
            <FAQs.FAQ question="Is it free?" />
            <FAQs.FAQ question="Can I use these projects in my portfolio?" />
            <FAQs.FAQ question="What are points for, and how does the points system work?" />
            <FAQs.FAQ question="Can I use these challenges within my own free or commercial content/tutorials/projects?" />
          </FAQs>

          <FAQs heading="Account questions">
            <FAQs.FAQ question="Is there any way to sign-up other than GitHub?" />
            <FAQs.FAQ question="How do I delete my account?" />
          </FAQs>

          <FAQs heading="Subscription questions">
            <FAQs.FAQ question="Can I get my employer to pay for my subscription?" />
            <FAQs.FAQ question="Do you offer discounts?" />
            <FAQs.FAQ question="Do you offer refunds?" />
            <FAQs.FAQ question="Can I cancel my subscription any time?" />
            <FAQs.FAQ question="I'm on the monthly subscription option and would like to upgrade to yearly. How can I do this?" />
            <FAQs.FAQ question="Does the subscription auto-renew?" />
            <FAQs.FAQ question="Why are there credits limits on the monthly subscription?" />
            <FAQs.FAQ question="Can I buy a subscription as a gift for someone else?" />
          </FAQs>

          <FAQs heading="Challenge FAQs">
            <FAQs.FAQ question="How can I get help if I'm stuck on a challenge?" />
            <FAQs.FAQ question="Can I use libraries/frameworks on these projects?" />
            <FAQs.FAQ question="How often are new challenges added?" />
            <FAQs.FAQ question="What is the difference between the desktop-design, mobile-design, and desktop-preview images in my starter code?" />
          </FAQs>

          <FAQs heading="Solution questions">
            <FAQs.FAQ question="How do I submit my solution?" />
            <FAQs.FAQ question="How do I edit my solution?" />
            <FAQs.FAQ question="How do I delete my solution?" />
            <FAQs.FAQ question="How do I generate a new solution screenshot?" />
            <FAQs.FAQ question="Is there an official solution I can take a look at?" />
            <FAQs.FAQ question="Do I get a code review when I post my solution?" />
            <FAQs.FAQ question="Why does my solution screenshot look different to the live version?" />
          </FAQs>

          <FAQs heading="Licensing questions">
            <FAQs.FAQ question="Can I stream myself completing Frontend Mentor challenges?" />
            <FAQs.FAQ question="Can I use Frontend Mentor challenges within my free course/tutorial?" />
            <FAQs.FAQ question="I want to use Frontend Mentor challenges in a commercial course/tutorial/project. Is this possible?" />
          </FAQs>
        </div>

        <div className="container-xl">
          <Callout
            heading="Didn't find an answer to your question?"
            theme="dark"
          >
            <p className="max-w-prose">
              Contact us at{' '}
              <NextLink
                className="underline hover:no-underline"
                href="mailto:hi@frontendmentor.io"
              >
                hi@frontendmentor.io
              </NextLink>{' '}
              and we’ll get back to you as soon as we can. Heads up that reply
              times are usually slower over the weekend.
            </p>
          </Callout>
        </div>
      </div>
    </>
  );
}
